import { OwnerCellProps } from './OwnerCell.types';
import { TableBodyCell } from '../../../../../MyTickets.styled';
import { Persona } from '@fluentui/react-components';

export const OwnerCell = ({ owner }: OwnerCellProps) => {
  return (
    <TableBodyCell>
      <Persona textAlignment="center" name={owner} />
    </TableBodyCell>
  );
};
